var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"reader",attrs:{"id":"readerQRCode"}})
}
var staticRenderFns = []

export { render, staticRenderFns }